
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Parentlogo extends Vue {
  getImgPath() {
    return require(`@/assets/images/${this.$t("ltsLogoPath")}`);
  }
}
